import React from 'react';
import "./css/dashboard.css";
import {API_URI} from "../../constant/Config"
import {t} from '../../constant/i18n';
import {Typography, Form, Input, Button, Checkbox, Space, DatePicker, Divider, Row, Col, notification} from "antd";
import axios from "axios";
import OrderFlightNoNecessary from "./OrderFlightNoNecessary";
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import moment from 'moment-timezone';
moment.tz.setDefault("Europe/Paris");
//import moment from "moment";


const {RangePicker} = DatePicker;
const {Title,Text} = Typography;

class OrderFlight extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            type: this.props.type,
            dataVols: false,
            dataCmd: this.props.dataCmd,
        }
    }

    async componentDidMount() {
        var token = localStorage.getItem('membre_token');
        const vols = await axios.post(API_URI + '/api_member/get_flights', {id: this.state.id, type: this.state.type}, {
            headers: {
                'Authorization': token
            }
        });




        await this.setState({dataVols: vols})
    }

    onFinish = async values => {
        const postData = {
            ...values,
            id: this.state.id,
            type: this.state.type,
        }
        var token = localStorage.getItem('membre_token');
        console.log(postData)

        const res = await axios.post(API_URI + '/api_member/add_flights', postData, {
            headers: {
                'Authorization': token
            }
        });


        const vols = await axios.post(API_URI + '/api_member/get_flights', {id: this.state.id, type: this.state.type}, {
            headers: {
                'Authorization': token
            }
        });
        await this.setState({dataVols: vols})

        notification.info({
            message: t('orderFlight.notif'),
            description: t('orderFlight.flightsAdded'),
        });
    }

    updateInfosVols = async (values, id) => {
        const postData = {
            ...values,
            id: id,
            idCmd: this.state.dataVols.data.idOrder,
        }
        var token = localStorage.getItem('membre_token');
        await axios.post(API_URI + '/api_member/update_flights', postData, {
            headers: {
                'Authorization': token
            }
        });

        notification.info({
            message: t('orderFlight.notif'),
            description: t('orderFlight.flightUpdated'),
        });
    }

    delVol = async id => {
        var token = localStorage.getItem('membre_token');
        const res = await axios.post(API_URI + '/api_member/del_flights', {
            id: id,
            idCmd: this.state.dataVols.data.idOrder
        }, {
            headers: {
                'Authorization': token
            }
        });
        const vols = await axios.post(API_URI + '/api_member/get_flights', {id: this.state.id, type: this.state.type}, {
            headers: {
                'Authorization': token
            }
        });
        await this.setState({dataVols: vols})
    }

    bocVolss = () => {
        const datavol = this.state.dataVols;
        const listItems = datavol.data.dataFormat.map((item, index) =>
            <div>
                <Form onFinish={(data, id) => this.updateInfosVols(data, item.idvolEscales)}>
                    <Form.Item
                        label={t('orderFlight.flightNum')}
                        name="volEscalescolNumeroVol"
                        rules={[{required: true, message: t('orderFlight.missingInfo')}]}
                        initialValue={item.volEscalescolNumeroVol}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('orderFlight.flightCompany')}
                        name="volEscalescolCompagnieVol"
                        rules={[{required: true, message: t('orderFlight.missingInfo')}]}
                        initialValue={item.volEscalescolCompagnieVol}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('orderFlight.takeoffDateTime')}
                        name="volEscalescolDatetimeDepart"
                        rules={[{required: true, message: t('orderFlight.missingInfo')}]}
                        initialValue={moment(item.volEscalescolDatetimeDepart)}
                    >
                        <DatePicker
                            showTime={{format: 'HH:mm'}}
                            format="YYYY-MM-DD HH:mm"
                        />
                    </Form.Item>

                    <Form.Item
                        label={t('orderFlight.arrivalDateTime')}
                        name="volEscalescolDatetimeArrivee"
                        rules={[{required: true, message: t('orderFlight.missingInfo')}]}
                        initialValue={moment(item.volEscalescolDatetimeArrivee)}
                    >
                        <DatePicker
                            showTime={{format: 'HH:mm'}}
                            format="YYYY-MM-DD HH:mm"
                        />
                    </Form.Item>

                    <Form.Item
                        label={t('orderFlight.depAirport')}
                        name="volEscalescolAeroportProvenance"
                        rules={[{required: true, message: t('orderFlight.missingInfo')}]}
                        initialValue={item.volEscalescolAeroportProvenance}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('orderFlight.arrAirport')}
                        name="volEscalescolAeroportArrivee"
                        rules={[{required: true, message: t('orderFlight.missingInfo')}]}
                        initialValue={item.volEscalescolAeroportArrivee}
                    >
                        <Input/>
                    </Form.Item>


                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            {t('orderFlight.update')}
                        </Button>

                        <Button type="primary" danger style={{marginLeft: 5}}
                                onClick={(id) => this.delVol(item.idvolEscales)}>
                            {t('orderFlight.delete')}
                        </Button>
                    </Form.Item>
                </Form>
                <Divider dashed={true}/>
            </div>
        );
        return listItems
    }

    render() {
        return (
            <div>

                <OrderFlightNoNecessary dataCmd={this.state.dataCmd} filghtType={this.state.type} />

                <br />

                <Title level={3}>{t('orderFlight.addFlight')}</Title>
                <Form name="dynamic_form_nest_item" onFinish={this.onFinish} autoComplete="off">
                    <Form.List name="vols">
                        {(fields, {add, remove}) => (
                            <div>
                                {fields.map(field => (
                                    <Row>
                                        <Col span={24}>
                                            <Row justify="start">
                                                <Col span={24}>
                                                    <Text strong>{t('orderFlight.numAndCompany')}</Text>
                                                    <br />
                                                    <Space align="center">
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, 'volEscalescolNumeroVol']}
                                                            fieldKey={[field.fieldKey, 'volEscalescolNumeroVol']}
                                                            rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                                        >
                                                            <Input placeholder={t('orderFlight.flightNum')}/>
                                                        </Form.Item>

                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, 'volEscalescolCompagnieVol']}
                                                            fieldKey={[field.fieldKey, 'volEscalescolCompagnieVol']}
                                                            rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                                        >
                                                            <Input placeholder={t('orderFlight.flightCompany')}/>
                                                        </Form.Item>
                                                    </Space>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <Text strong>{t('orderFlight.iLeaveFrom')}</Text>
                                                    <br />
                                                    <Space align="center">
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, 'volEscalescolAeroportProvenance']}
                                                            fieldKey={[field.fieldKey, 'volEscalescolAeroportProvenance']}
                                                            rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                                        >
                                                            <Input
                                                                placeholder={t('orderFlight.depAirportPlaceholder')}/>
                                                        </Form.Item>

                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, 'volEscalescolDatetimeDepart']}
                                                            fieldKey={[field.fieldKey, 'volEscalescolDatetimeDepart']}
                                                            rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                                        >
                                                            <DatePicker
                                                                showTime={{format: 'HH:mm'}}
                                                                format="YYYY-MM-DD HH:mm"
                                                                placeholder={[t('orderFlight.takeoffPlaceholder')]}
                                                            />
                                                        </Form.Item>
                                                    </Space>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col span={24}>
                                                    <Text strong>{t('orderFlight.iArriveAt')}</Text>
                                                    <br />
                                                    <Space align="center">
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, 'volEscalescolAeroportArrivee']}
                                                            fieldKey={[field.fieldKey, 'volEscalescolAeroportArrivee']}
                                                            rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                                        >
                                                            <Input placeholder={t('orderFlight.arrAirport')}/>
                                                        </Form.Item>

                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, 'volEscalescolDatetimeArrivee']}
                                                            fieldKey={[field.fieldKey, 'volEscalescolDatetimeArrivee']}
                                                            rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                                        >
                                                            <DatePicker
                                                                showTime={{format: 'HH:mm'}}
                                                                format="YYYY-MM-DD HH:mm"
                                                                placeholder={[t('orderFlight.landingPlaceholder')]}
                                                            />
                                                        </Form.Item>
                                                    </Space>
                                                </Col>
                                            </Row>

                                            <MinusCircleOutlined onClick={() => remove(field.name)}/>
                                        </Col>
                                    </Row>
                                ))}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                        {t('orderFlight.addFlight')}
                                    </Button>
                                </Form.Item>
                            </div>
                        )}
                    </Form.List>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            {t('orderFlight.validateFlights')}
                        </Button>
                    </Form.Item>
                </Form>
                <Divider/>
                <Title level={3}>{t('orderFlight.myFlights')}</Title>
                {(this.state.dataVols) ? this.bocVolss() : t('orderFlight.loading')}
            </div>
        )
    }
}

export default OrderFlight